module.exports = __webpack_public_path__ + "img/Heatmap.b869bb0d.webp";